export default __webpack_public_path__ + "static/media/Resources_By_Activity.815ec562.png";